import React from "react";

const About = () => {
  return (
    <div className="bg-slate-50/50 py-16 sm:py-24">
      {/* Title / Header */}
      <div className="max-w-3xl mx-auto text-center mb-6 px-4" data-aos="fade-up">
        {/* Graduation Cap Decoration with Stars */}
        <div className="flex items-center justify-center gap-4 mb-4">
          <div className="h-[1.5px] w-12 sm:w-20 bg-gray-300"></div>
          <div className="flex items-center gap-1 text-[#1e3a8a]">
            {/* Left Star */}
            <svg className="w-3.5 h-3.5 text-amber-400 fill-amber-400" viewBox="0 0 24 24">
              <polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9" />
            </svg>
            {/* Graduation Cap SVG */}
            <svg className="w-8 h-8 text-slate-800" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
              <path d="M12 17.27l-5-2.73V11l-2 1.09v3.45l7 3.82 7-3.82v-3.45l-2-1.09v3.54l-5 2.73z"/>
            </svg>
            {/* Right Star */}
            <svg className="w-3.5 h-3.5 text-amber-400 fill-amber-400" viewBox="0 0 24 24">
              <polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9" />
            </svg>
          </div>
          <div className="h-[1.5px] w-12 sm:w-20 bg-gray-300"></div>
        </div>
        
        <h1 className="text-3xl sm:text-4.5xl font-black tracking-tight text-[#111827] uppercase leading-none">
          Everything You Need,
        </h1>
        <h1 className="text-3.5xl sm:text-5xl font-black tracking-tight text-[#2563eb] uppercase mt-2 leading-none">
          All In One Place
        </h1>

        {/* Subtitle with Side Lines */}
        <div className="flex items-center justify-center gap-3 mt-5">
          <div className="h-[1px] w-10 sm:w-16 bg-gray-200"></div>
          <p className="text-gray-500 text-xs sm:text-sm font-semibold tracking-wide">
            Your Complete Study Solution for <span className="text-[#2563eb] font-bold">BDS Students</span>
          </p>
          <div className="h-[1px] w-10 sm:w-16 bg-gray-200"></div>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-4">
        {/* 1. DETAILED NOTES CARD */}
        <div className="bg-white border border-slate-100 rounded-3xl p-6 sm:p-10 shadow-[0_10px_35px_rgba(0,0,0,0.02)] relative mb-4" data-aos="fade-up">
          {/* Header with Ribbon */}
          <div className="relative mb-8 flex items-center pt-2 sm:pt-4">
            {/* Circle Icon */}
            <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#102a43] border-4 border-white shadow-md flex items-center justify-center text-white z-20 flex-shrink-0">
              <svg className="w-6 h-6 sm:w-7 sm:h-7" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
            {/* Ribbon shape with custom chevron cut-out on the right */}
            <div 
              className="bg-gradient-to-r from-[#1e40af] to-[#2563eb] text-white pl-8 pr-12 py-3 rounded-r-none font-black text-base sm:text-lg tracking-wider uppercase z-10 -ml-6 shadow-sm relative flex items-center"
              style={{ clipPath: "polygon(0 0, 94% 0, 100% 50%, 94% 100%, 0 100%)" }}
            >
              Detailed Course
            </div>
          </div>

          <p className="text-slate-505 font-semibold text-sm mb-8 pl-1">
            Complete, Organized & Exam-Focused
          </p>

          {/* Timeline List */}
          <div className="relative space-y-8 my-6">
            {/* Vertical Line shifted to the right of the icons */}
            <div className="absolute left-[63px] sm:left-[87px] top-6 sm:top-8 bottom-6 sm:bottom-8 w-[2px] bg-slate-200"></div>

            {/* Item 1: Chapter-wise Notes */}
            <div className="relative flex items-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-[#eff6ff] border border-[#bfdbfe] flex items-center justify-center text-[#1e40af] shadow-sm flex-shrink-0">
                <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <div className="w-8 sm:w-12 flex-shrink-0 flex items-center justify-center relative">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#1e40af] z-10"></div>
              </div>
              <div className="flex-1 pt-0.5">
                <h3 className="text-sm sm:text-base font-black text-[#1e3a8a] leading-tight">Chapter-wise Notes</h3>
                <p className="text-xs sm:text-sm text-slate-500 font-medium mt-1 leading-relaxed">Detailed and easy-to-understand notes for every chapter.</p>
              </div>
            </div>

            {/* Item 2: Chapter-wise Questions */}
            <div className="relative flex items-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-[#f0fdf4] border border-[#bbf7d0] flex items-center justify-center text-[#16a34a] shadow-sm flex-shrink-0">
                <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                </svg>
              </div>
              <div className="w-8 sm:w-12 flex-shrink-0 flex items-center justify-center relative">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#15803d] z-10"></div>
              </div>
              <div className="flex-1 pt-0.5">
                <h3 className="text-sm sm:text-base font-black text-[#15803d] leading-tight">Chapter-wise Questions</h3>
                <p className="text-xs sm:text-sm text-slate-500 font-medium mt-1 leading-relaxed">Important questions for every chapter to improve your practice.</p>
              </div>
            </div>

            {/* Item 3: Chapter-wise Flash Card Videos */}
            <div className="relative flex items-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-[#faf5ff] border border-[#e9d5ff] flex items-center justify-center text-[#7c3aed] shadow-sm flex-shrink-0">
                <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <rect x="2" y="4" width="20" height="16" rx="3" stroke="currentColor" />
                  <polygon points="10,9 15,12 10,15" fill="currentColor" />
                </svg>
              </div>
              <div className="w-8 sm:w-12 flex-shrink-0 flex items-center justify-center relative">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#6d28d9] z-10"></div>
              </div>
              <div className="flex-1 pt-0.5">
                <h3 className="text-sm sm:text-base font-black text-[#6d28d9] leading-tight">Chapter-wise Flash Card Videos</h3>
                <p className="text-xs sm:text-sm text-slate-500 font-medium mt-1 leading-relaxed">Short, crisp flash card videos for each chapter for better understanding and quick revision.</p>
              </div>
            </div>

            {/* Item 4: Priority-wise Question List */}
            <div className="relative flex items-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-[#fff7ed] border border-[#fed7aa] flex items-center justify-center text-[#ea580c] shadow-sm flex-shrink-0">
                <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg>
              </div>
              <div className="w-8 sm:w-12 flex-shrink-0 flex items-center justify-center relative">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#c2410c] z-10"></div>
              </div>
              <div className="flex-1 pt-0.5">
                <h3 className="text-sm sm:text-base font-black text-[#c2410c] leading-tight">Priority-wise Question List</h3>
                <p className="text-xs sm:text-sm text-slate-500 font-medium mt-1 leading-relaxed">Most important questions arranged by priority to save your time and boost your score.</p>
              </div>
            </div>

            {/* Item 5: Flash Card - Quick Revision List */}
            <div className="relative flex items-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-[#f0fdf4] border border-[#99f6e4] flex items-center justify-center text-[#0d9488] shadow-sm flex-shrink-0">
                <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 3h12a3 3 0 013 3v10a3 3 0 01-3 3H6a3 3 0 01-3-3V6a3 3 0 013-3z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 10.5l2-2h4m-4 4l-2-2" />
                </svg>
              </div>
              <div className="w-8 sm:w-12 flex-shrink-0 flex items-center justify-center relative">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#0f766e] z-10"></div>
              </div>
              <div className="flex-1 pt-0.5">
                <h3 className="text-sm sm:text-base font-black text-[#0f766e] leading-tight">Flash Card - Quick Revision List</h3>
                <p className="text-xs sm:text-sm text-slate-500 font-medium mt-1 leading-relaxed">Quick revision list in flash card style to revise anytime, anywhere.</p>
              </div>
            </div>
          </div>
        </div>

        {/* PLUS CONNECTOR */}
        <div className="flex justify-center my-[-22px] relative z-20" data-aos="zoom-in">
          <div className="w-11 h-11 rounded-full bg-gradient-to-b from-[#2563eb] to-[#1d4ed8] text-white flex items-center justify-center shadow-[0_4px_14px_rgba(37,99,235,0.45)] border-2 border-white">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" strokeWidth="4.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
          </div>
        </div>

        {/* 2. CRASH COURSE CARD */}
        <div className="bg-white border border-slate-100 rounded-3xl p-6 sm:p-10 shadow-[0_10px_35px_rgba(0,0,0,0.02)] relative mt-0" data-aos="fade-up">
          {/* Header with Ribbon */}
          <div className="relative mb-8 flex items-center pt-2 sm:pt-4">
            {/* Circle Icon */}
            <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#610b0b] border-4 border-white shadow-md flex items-center justify-center text-white z-20 flex-shrink-0">
              <svg className="w-6 h-6 sm:w-7 sm:h-7" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0zM12 2v2M9 2h6" />
              </svg>
            </div>
            {/* Ribbon shape with custom chevron cut-out on the right */}
            <div 
              className="bg-gradient-to-r from-[#ef4444] to-[#f87171] text-white pl-8 pr-12 py-3 rounded-r-none font-black text-base sm:text-lg tracking-wider uppercase z-10 -ml-6 shadow-sm relative flex items-center"
              style={{ clipPath: "polygon(0 0, 94% 0, 100% 50%, 94% 100%, 0 100%)" }}
            >
              Crash Course
            </div>
          </div>

          <p className="text-slate-505 font-semibold text-sm mb-8 pl-1">
            Revise Fast. Remember More. Score Higher.
          </p>

          {/* Timeline List */}
          <div className="relative space-y-8 my-6">
            {/* Vertical Line shifted to the right of the icons */}
            <div className="absolute left-[63px] sm:left-[87px] top-6 sm:top-8 bottom-6 sm:bottom-8 w-[2px] bg-slate-200"></div>

            {/* Item 1: Complete Syllabus Revision */}
            <div className="relative flex items-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-[#fff5f5] border border-[#feb2b2] flex items-center justify-center text-[#e53e3e] shadow-sm flex-shrink-0">
                <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" />
                  <circle cx="12" cy="12" r="6" stroke="currentColor" />
                  <circle cx="12" cy="12" r="2" stroke="currentColor" fill="currentColor" />
                </svg>
              </div>
              <div className="w-8 sm:w-12 flex-shrink-0 flex items-center justify-center relative">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#c53030] z-10"></div>
              </div>
              <div className="flex-1 pt-0.5">
                <h3 className="text-sm sm:text-base font-black text-[#c53030] leading-tight">Complete Syllabus Revision</h3>
                <p className="text-xs sm:text-sm text-slate-500 font-medium mt-1 leading-relaxed">Cover the entire syllabus quickly and effectively in less time.</p>
              </div>
            </div>

            {/* Item 2: Concise Answers */}
            <div className="relative flex items-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-[#fff5f5] border border-[#feb2b2] flex items-center justify-center text-[#e53e3e] shadow-sm flex-shrink-0">
                <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                </svg>
              </div>
              <div className="w-8 sm:w-12 flex-shrink-0 flex items-center justify-center relative">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#c53030] z-10"></div>
              </div>
              <div className="flex-1 pt-0.5">
                <h3 className="text-sm sm:text-base font-black text-[#c53030] leading-tight">Concise Answers</h3>
                <p className="text-xs sm:text-sm text-slate-500 font-medium mt-1 leading-relaxed">Short, to-the-point and exam-ready answers to help you write better in exams.</p>
              </div>
            </div>

            {/* Item 3: High-Yield Content */}
            <div className="relative flex items-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-[#fff5f5] border border-[#feb2b2] flex items-center justify-center text-[#e53e3e] shadow-sm flex-shrink-0">
                <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.63 8.41a14.98 14.98 0 00-6.16 12.12 14.98 14.98 0 0012.12-6.16zM9.63 8.41l-3.36-3.36M15.59 14.37l3.36 3.36" />
                </svg>
              </div>
              <div className="w-8 sm:w-12 flex-shrink-0 flex items-center justify-center relative">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#c53030] z-10"></div>
              </div>
              <div className="flex-1 pt-0.5">
                <h3 className="text-sm sm:text-base font-black text-[#c53030] leading-tight">High-Yield Content</h3>
                <p className="text-xs sm:text-sm text-slate-500 font-medium mt-1 leading-relaxed">Only the most important topics and answers that bring maximum impact.</p>
              </div>
            </div>

            {/* Item 4: Time-Saving & Score-Boosting */}
            <div className="relative flex items-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-[#fff5f5] border border-[#feb2b2] flex items-center justify-center text-[#e53e3e] shadow-sm flex-shrink-0">
                <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.5 4.5L21.75 7.5M21.75 7.5V12m0-4.5H17.25" />
                </svg>
              </div>
              <div className="w-8 sm:w-12 flex-shrink-0 flex items-center justify-center relative">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#c53030] z-10"></div>
              </div>
              <div className="flex-1 pt-0.5">
                <h3 className="text-sm sm:text-base font-black text-[#c53030] leading-tight">Time-Saving & Score-Boosting</h3>
                <p className="text-xs sm:text-sm text-slate-500 font-medium mt-1 leading-relaxed">Smart revision strategy to help you complete revision and boost your score.</p>
              </div>
            </div>
          </div>
        </div>

        {/* 3. BOTTOM RESULTS SUMMARY BAR */}
        <div className="bg-amber-50 border border-amber-100 rounded-3xl p-5 flex items-center gap-4 shadow-sm" data-aos="fade-up">
          <div className="w-12 h-12 rounded-xl bg-amber-500 flex items-center justify-center text-white flex-shrink-0 shadow-sm">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.504-1.125-1.125-1.125h-5.25c-.621 0-1.125.504-1.125 1.125v3.375m9 0h-9M12 14.25v3.75m8.25-9.75h-1.5V9A6.75 6.75 0 0012 2.25 6.75 6.75 0 005.25 9v.75H3.75A2.25 2.25 0 001.5 12v.75A2.25 2.25 0 003.75 15h1.5a6.72 6.72 0 002.593 4.237M18.75 15h1.5a2.25 2.25 0 002.25-2.25V12a2.25 2.25 0 00-2.25-2.25z" />
            </svg>
          </div>
          <div>
            <h4 className="text-[#78350f] font-black text-sm sm:text-base leading-tight">
              SMART NOTES + SMART REVISION = TOP RESULTS
            </h4>
            <p className="text-[#92400e] text-xs sm:text-sm font-semibold mt-0.5">
              Study smart, revise smart, and achieve your best!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
